export const timelineVisRestrictions = {
  systemFit: {
    1: "System Fit can’t be viewed at match level. We need more than one matches’ worth of data for it to work.",
    2: "allow",
    3: "allow",
    4: "allow"
  },
  passingNetwork: {
    1: "allow",
    2: "Passing networks work for single matches only. Select a match to view.",
    3: "Passing networks work for single matches only. Select a match to view.",
    4: "Passing networks work for single matches only. Select a match to view."
  },
  optimalPathways: {
    1: "allow",
    2: "allow",
    3: "allow",
    4: "allow"
  },
  areasOfControl: {
    1: "Areas of Control need more than one match worth of data for it to work. Please zoom out in the timeline",
    2: "allow",
    3: "allow",
    4: "allow"
  },
  flowOfPlay: {
    1: "allow",
    2: "Flow of Play work for single matches only. Select a match to view.",
    3: "Flow of Play work for single matches only. Select a match to view.",
    4: "Flow of Play work for single matches only. Select a match to view."
  },
  threatMap: {
    1: "allow",
    2: "allow",
    3: "allow",
    4: ""
  },
  riskMap: {
    1: "Risk Map need more than one match worth of data for it to work. Please zoom out in the timeline",
    2: "allow",
    3: "allow",
    4: "allow"
  },
  passingAttack: {
    1: "allow",
    2: "Passing Attacks work for single matches only. Select a match to view.",
    3: "Passing Attacks work for single matches only. Select a match to view.",
    4: "Passing Attacks work for single matches only. Select a match to view."
  },
  minus: {
    1: "allow",
    2: "allow",
    3: "allow",
    4: "allow"
  }
};
